import { render, staticRenderFns } from "./SidebarItem.vue?vue&type=template&id=5c6be7d2&scoped=true&"
import script from "./SidebarItem.vue?vue&type=script&lang=ts&"
export * from "./SidebarItem.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarItem.vue?vue&type=style&index=0&id=5c6be7d2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6be7d2",
  null
  
)

export default component.exports